// @flow
import { omit } from 'lodash';

import {
  EDUCATIONS_REQUEST,
  EDUCATIONS_REQUESTED,
  EDUCATIONS_REQUESTED_ERROR,
  EDUCATION_CREATE,
  EDUCATION_CREATED,
  EDUCATION_CREATED_ERROR,
  EDUCATION_UPDATE,
  EDUCATION_UPDATED,
  EDUCATION_UPDATED_ERROR,
  EDUCATION_DELETE,
  EDUCATION_DELETED,
  EDUCATION_DELETED_ERROR,
  EDUCATION_RESET
} from './constants';

import type { Action, State } from '../types';

const initialState: State = {
  data: [],
  getStatus: {
    requesting: false,
    error: null
  },
  createStatus: {
    requesting: false,
    error: null
  },
  updateStatus: {
    requesting: [],
    error: {}
  },
  deleteStatus: {
    requesting: [],
    error: {}
  }
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case EDUCATIONS_REQUEST:
      return {
        ...state,
        getStatus: {
          requesting: true,
          error: null
        }
      };
    case EDUCATIONS_REQUESTED: {
      return {
        ...state,
        data: action.data,
        getStatus: {
          requesting: false,
          error: null
        }
      };
    }
    case EDUCATIONS_REQUESTED_ERROR: {
      return {
        ...state,
        getStatus: {
          requesting: false,
          error: action.error
        }
      };
    }
    case EDUCATION_CREATE:
      return {
        ...state,
        createStatus: {
          requesting: true,
          error: null
        }
      };
    case EDUCATION_CREATED:
      return {
        ...state,
        createStatus: {
          requesting: false,
          error: null
        }
      };
    case EDUCATION_CREATED_ERROR: {
      return {
        ...state,
        createStatus: {
          requesting: false,
          error: action.error
        }
      };
    }
    case EDUCATION_UPDATE: {
      return {
        ...state,
        updateStatus: {
          ...state.updateStatus,
          requesting: [...state.updateStatus.requesting, action.id]
        }
      };
    }
    case EDUCATION_UPDATED: {
      return {
        ...state,
        updateStatus: {
          requesting: state.updateStatus.requesting.filter(v => v !== action.id),
          error: omit(state.updateStatus.error, action.id)
        }
      };
    }
    case EDUCATION_UPDATED_ERROR: {
      return {
        ...state,
        updateStatus: {
          requesting: state.updateStatus.requesting.filter(v => v !== action.id),
          error: {
            ...state.updateStatus.error,
            [action.id]: action.error
          }
        }
      };
    }
    case EDUCATION_DELETE: {
      return {
        ...state,
        deleteStatus: {
          ...state.deleteStatus,
          requesting: [...state.deleteStatus.requesting, action.id]
        }
      };
    }
    case EDUCATION_DELETED: {
      return {
        ...state,
        deleteStatus: {
          requesting: state.deleteStatus.requesting.filter(v => v !== action.id),
          error: omit(state.deleteStatus.error, action.id)
        }
      };
    }
    case EDUCATION_DELETED_ERROR: {
      return {
        ...state,
        deleteStatus: {
          requesting: state.deleteStatus.requesting.filter(v => v !== action.id),
          error: {
            ...state.deleteStatus.error,
            [action.id]: action.error
          }
        }
      };
    }
    case EDUCATION_RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
